<template>
  <!--<el-input-->
  <!--    v-model="displayValue"-->
  <!--    :placeholder="placeholder"-->
  <!--    :show-word-limit="showWordLimit"-->
  <!--    @focus="handleFocus"-->
  <!--    @blur="handleBlur"-->
  <!--    @input="handleInput"-->
  <!--    v-bind="$attrs"-->
  <!--&gt;</el-input>-->
  <el-input
      v-model="displayValue"
      :placeholder="placeholder"
      :show-word-limit="showWordLimit"
      @mouseenter.native="handleFocus"
      @mouseleave.native="handleBlur"
      @input="handleInput"
      v-bind="$attrs"
  ></el-input>
</template>

<script>
import { maskMobile } from '@/utils/common';
export default {
  name: 'MaskedInput',
  props: {
    // 原始值（双向绑定）
    value: {
      type: String,
      default: ''
    },
    // 透传placeholder
    placeholder: {
      type: String,
      default: ''
    },
    // 透传显示字数限制
    showWordLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayValue: '', // 输入框显示的值（可能是脱敏后的值）
      isFocused: false // 是否聚焦
    };
  },
  watch: {
    // 监听原始值变化，同步更新显示
    value: {
      immediate: true,
      handler(val) {
        this.displayValue = this.isFocused ? val : maskMobile(val);
      }
    }
  },
  methods: {
    // 聚焦时显示完整值
    handleFocus() {
      this.isFocused = true;
      this.displayValue = this.value;
    },
    // 失焦时显示脱敏值
    handleBlur() {
      this.isFocused = false;
      this.displayValue = maskMobile(this.value);
    },
    // 输入时同步更新原始值
    handleInput(val) {
      this.$emit('input', val); // 触发v-model更新
    }
  }
};
</script>
